import { apiBaseUrl } from '../../backend/config.js';
import { socket, getPortfolioId } from './socketU.js'; 
import { getAuthToken } from './auth.js';
import { t, confirmT, updateElementText } from './translationHelper.js';

// Translation helper function


const showNotification = (message, isSuccess) => {
  const notification = document.createElement('div');
  notification.style = `
	position: fixed; bottom: 8%; right: -100%; 
	width: 80%; 
	max-width: 100%; 
	margin-left: auto; 
	margin-right: auto; 
	left: 5%; 
	background-color: ${isSuccess ? 'rgba(0, 255, 0, 0.9)' : 'rgba(255, 0, 0, 0.9)'}; 
	padding: 20px; border-radius: 5px; border: 2px solid #00ff00; 
	color: #000000; font-family: 'bithigh', Arial, sans-serif; 
	z-index: 10001; text-align: center; 
	transition: right 0.5s ease-out;
  `;
  notification.innerHTML = `<p style="color: #000000;">${message}</p>`;
  document.body.appendChild(notification);

  setTimeout(() => {
	notification.style.right = '10%';
  }, 10);

  setTimeout(() => {
	notification.style.right = '-100%'; 
	setTimeout(() => notification.remove(), 500);
  }, 2000);
};

let communityTimer;
let communityId;

function showCommunityInvitationPopup(data) {
  console.log('Showing community invitation popup');
  const popup = document.createElement('div');
  popup.id = 'communityInvitationPopup';
  popup.style = `
	position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
	background-color: rgba(0, 0, 0, 0.85); padding: 20px; border-radius: 10px;
	z-index: 1000; color: #00ff00; font-family: 'bithigh', sans-serif; width: 98%; max-width:98%;
	height:98%; max-height:98%; align-content: center;
  `;

  popup.innerHTML = `
	<h2>${t('Dark Pool Invitation', 'Dark Pool Invitation')}</h2>
	<p>${t('Join the dark pool for exclusive trading.', 'Join the dark pool for exclusive trading.')}</p>
	<p>${t('The dark pool will be active for 10 minutes.', 'The dark pool will be active for 10 minutes.')}</p>
	<div style="display: flex; justify-content: space-between; margin-top: 20px;">
	  <button id="acceptCommunity" style="padding: 10px 20px; cursor: pointer;">${t('Accept', 'Accept')}</button>
	  <button id="declineCommunity" style="padding: 10px 20px; cursor: pointer;">${t('Decline', 'Decline')}</button>
	</div>
  `;

  document.body.appendChild(popup);

  (function(invitationData) {
	const acceptButton = document.getElementById('acceptCommunity');
	const declineButton = document.getElementById('declineCommunity');

	if (acceptButton) {
	  acceptButton.addEventListener('click', function() {
		console.log('Accept button clicked');
		handleResponseCM(true, invitationData);
	  });
	} else {
	  console.error('Accept button not found');
	}

	if (declineButton) {
	  declineButton.addEventListener('click', function() {
		console.log('Decline button clicked');
		handleResponseCM(false, invitationData);
	  });
	} else {
	  console.error('Decline button not found');
	}
  })(data);
}

async function handleResponseCM(accept, data) {
  console.log('handleResponse called with:', accept, data);
  const portfolioId = getPortfolioId();
  const token = localStorage.getItem('token');

  if (!portfolioId) {
	console.error('Portfolio ID not found');
	showNotification('Error: Portfolio ID not found', false);
	return;
  }

  try {
	const response = await fetch(`${apiBaseUrl}/api/community/join`, {
		method: 'POST',
		headers: {
		  'Content-Type': 'application/json',
		  'Authorization': `Bearer ${token}`
		},
		body: JSON.stringify({
		  portfolioId,
		  communityId: data.communityId,
		  accept
		}) 
	  });

	if (!response.ok) {
	  const errorText = await response.text();
	  throw new Error(`Failed to process join request: ${response.status} ${errorText}`);
	}

	const result = await response.json();
	console.log('Join request result:', result);

	if (result.success) {
	  showNotification(result.message, true);
	  if (accept) {
		startCommunityTimer(data.communityId);
		showCommunityInterface(data.communityId);
		localStorage.setItem('activeCommunity', data.communityId);
	  }
	} else {
	  showNotification(result.message, false);
	}

	if (typeof socket !== 'undefined' && socket.connected) {
	  socket.emit('communityInvitationResponse', {
		portfolioId,
		communityId: data.communityId,
		accept
	  });
	  console.log('Emitted communityInvitationResponse event');
	}

  } catch (error) {
	  console.error('Error processing dark pool join request:', error);
	  showNotification(`Error: ${error.message}`, false);
	} finally {
	  const popupElement = document.getElementById('communityInvitationPopup');
	  if (popupElement) {
		popupElement.remove();
	  }
	}
  }

function startCommunityTimer(communityId) {
  console.log('Starting dark pool timer:', communityId);

  const storedEndTime = localStorage.getItem('communityTimerEnd');
  let endTime;
  
  if (storedEndTime) {
	endTime = parseInt(storedEndTime, 10);
  } else {
	endTime = Date.now() + 10 * 60 * 1000;
	localStorage.setItem('communityTimerEnd', endTime.toString());
  }

  const timerElement = document.getElementById('communityTimer') || createTimerElement();
  
  function updateTimer() {
	const now = Date.now();
	const timeLeft = Math.max(0, endTime - now);

	if (timeLeft > 0) {
	  const minutes = Math.floor(timeLeft / 60000);
	  const seconds = Math.floor((timeLeft % 60000) / 1000);
	  timerElement.textContent = `Dark Pool Clock: ${minutes}:${seconds.toString().padStart(2, '0')}`;
	  setTimeout(updateTimer, 1000);
	} else {
	  timerElement.textContent = 'Dark Pool Ended';
	  localStorage.removeItem('communityTimerEnd');
	  endCommunity(communityId);
	}
  }
  updateTimer();
}

function createTimerElement() {
  const timerElement = document.createElement('div');
  timerElement.id = 'communityTimer';
  timerElement.classList.add('community-timer'); 
  document.body.appendChild(timerElement);
  return timerElement;
}


function checkAndShowCommunityInterface(portfolioData) {

  if (portfolioData.inDarkPool) {

	const communityId = portfolioData.darkPoolId;
	startCommunityTimer(communityId);
	showCommunityInterface(communityId);
  } else {

	const communityTimer = document.getElementById('communityTimer');
	const communityInterface = document.getElementById('communityInterface');
	if (communityTimer) communityTimer.remove();
	if (communityInterface) communityInterface.remove();
	localStorage.removeItem('communityTimerEnd'); 
  }
}

async function showCommunityInterface(communityId) {
  console.log('Showing dark pool interface for community:', communityId);

  try {
	const response = await fetch(`${apiBaseUrl}/api/community/${communityId}`, {
	  method: 'GET',
	  headers: {
		'Content-Type': 'application/json',
		'Authorization': `Bearer ${localStorage.getItem('token')}` // Ensure the token is included
	  }
	});

	if (!response.ok) {
	  throw new Error('Failed to fetch dark pool details');
	}

	const community = await response.json();

	const interfaceElement = document.getElementById('communityInterface') || createInterfaceElement();
	interfaceElement.innerHTML = `
	  Dark Pool: ${community.poolName}
	  <button id="leaveCommunityBtn">${t('Leave Dark Pool', 'Leave Dark Pool')}</button>
	`;

	const leaveCommunityBtn = document.getElementById('leaveCommunityBtn');
	if (leaveCommunityBtn) {
	  leaveCommunityBtn.addEventListener('click', () => leaveCommunity(communityId));
	} else {
	  console.error('Leave dark pool button not found');
	}
  } catch (error) {
	console.error('Error fetching dark pool details:', error);
	showNotification('Error: Could not load dark pool details.', false);
  }
}


function createInterfaceElement() {
  const interfaceElement = document.createElement('div');
  interfaceElement.id = 'communityInterface';
  interfaceElement.classList.add('community-interface'); // Add this line to use the class from CSS
  document.body.appendChild(interfaceElement);
  return interfaceElement;
}

async function leaveCommunity(communityId) {
  console.log('Attempting to leave dark pool:', communityId);
  const portfolioId = getPortfolioId();
  const token = localStorage.getItem('token');

  if (!portfolioId || !token) {
	console.error('Portfolio ID or token not found');
	showNotification('Error: Unable to leave dark pool. Please try again.', false);
	return;
  }

  try {
	const response = await fetch(`${apiBaseUrl}/api/community/leave`, {
		method: 'POST',
		headers: {
		  'Content-Type': 'application/json',
		  'Authorization': `Bearer ${token}`
		},
		body: JSON.stringify({ portfolioId, communityId })
	  });

	const result = await response.json();

	if (!response.ok) {
	  throw new Error(result.message || `${t('Failed to leave dark pool:', 'Failed to leave dark pool:')} ${response.status} - ${response.statusText}`);
	}

	console.log('Left dark pool successfully:', result);

	if (result.success) {
	  // Update local storage and UI
	  localStorage.removeItem('communityTimerEnd');
	  const communityTimer = document.getElementById('communityTimer');
	  const communityInterface = document.getElementById('communityInterface');
	  if (communityTimer) communityTimer.remove();
	  if (communityInterface) communityInterface.remove();
	  showNotification(t('You have left the dark pool.', 'You have left the dark pool.'), true);
	  // Refresh the page or update the UI
	  setTimeout(() => location.reload(), 2000);
	} else {
	  throw new Error(result.message || 'Failed to leave community');
	}
  } catch (error) {
	console.error('Error leaving community:', error);
	showNotification(`Error: ${error.message}`, false);
  }
}

async function endCommunity(communityId) {
  console.log('Dark pool timer ended:', communityId);

  // Clean up UI elements
  const communityTimer = document.getElementById('communityTimer');
  const communityInterface = document.getElementById('communityInterface');
  if (communityTimer) communityTimer.remove();
  if (communityInterface) communityInterface.remove();

  showNotification(t('The dark pool has ended.', 'The dark pool has ended.'), true);

  // Optionally reload to refresh state
  setTimeout(() => location.reload(), 2000);
}

async function handleCreateCommunity() {
  try {
	const portfolioId = getPortfolioId();
	const sessionId = localStorage.getItem('sessionId'); // Retrieve the sessionId from localStorage
	console.log('Initiating dark pool creation from trader:', portfolioId);

	if (!portfolioId) {
	  throw new Error('Initiator trader ID is undefined');
	}

	if (!sessionId) {
	  throw new Error('Session ID is required to create a community.');
	}

	const activePortfoliosResponse = await fetch(`${apiBaseUrl}/api/portfolios/active`, {
	  method: 'POST',
	  headers: {
		'Authorization': `Bearer ${getAuthToken()}`,
		'Content-Type': 'application/json'
	  },
	  body: JSON.stringify({ sessionId }) 
	});


	if (!activePortfoliosResponse.ok) {
	  throw new Error('Failed to fetch active traders');
	}

	const activePortfolios = await activePortfoliosResponse.json();
	const eligiblePortfolios = activePortfolios.filter(p => p._id !== portfolioId && !p.isSuperUser);

	if (eligiblePortfolios.length < 2) {
	  showNotification(t('Not enough eligible portfolios to create a community. Action cancelled.', 'Not enough eligible portfolios to create a community. Action cancelled.'), false);
	  return;
	}

	const result = await showMultiUserSelectionPopup(eligiblePortfolios, portfolioId); // Pass portfolioId
	if (!result || !result.selectedUserIds || result.selectedUserIds.length < 2 || !result.poolName) {
	  showNotification(t('Please select at least two members and provide a pool name. Action cancelled.', 'Please select at least two members and provide a pool name. Action cancelled.'), false);
	  return;
	}

	const { selectedUserIds, poolName } = result;

	// Ensure the initiator's portfolio is included in the community
	if (!selectedUserIds.includes(portfolioId)) {
	  selectedUserIds.push(portfolioId);
	}

	if (socket && socket.connected) {
	  // Emit the createCommunity event
	  socket.emit('createCommunity', {
		initiatorPortfolioId: portfolioId,
		selectedPortfolioIds: selectedUserIds,
		poolName
	  });

	  return new Promise((resolve, reject) => {
		showNotification(t('Community creation request sent. Waiting for server confirmation.', 'Community creation request sent. Waiting for server confirmation.'), true);

		socket.once('communityCreationStatus', (data) => {
		  console.log('Received communityCreationStatus:', data);
		  if (data.success) {
			startCommunityTimer(data.communityId);
			showCommunityInterface(data.communityId);
			localStorage.setItem('activeCommunity', data.communityId);
			showNotification(data.message, true);
			resolve(data);
		  } else {
			showNotification(`Error: ${data.message}`, false);
			reject(new Error(data.message));
		  }
		});
	  });
	} else {
	  throw new Error('connection is not open.');
	}
  } catch (error) {
	console.error('Error creating community:', error);
	showNotification(`Error: Could not create community. ${error.message}`, false);
  }
}


async function initializeCreateCommunityButton() {
  const createCommunityButton = document.getElementById('createCommunityButton');

  if (createCommunityButton) {
	createCommunityButton.classList.remove('hiddenCM');
	if (!createCommunityButton.hasEventListener) {
	  createCommunityButton.addEventListener('click', handleCreateCommunity);
	  createCommunityButton.hasEventListener = true;
	}
  } else {
	console.error('Create Dark Pool button not found in the DOM');
  }
}

function showMultiUserSelectionPopup(users, initiatorId) {
  return new Promise((resolve) => {
	const popup = document.createElement('div');
	popup.id = 'multiUserSelectionPopup';
	popup.innerHTML = `
	  <h2>${t('Enter Dark Pool Name:', 'Enter Dark Pool Name:')}</h2>
	  <input type="text" id="poolNameInput" placeholder="${t('Enter dark pool name', 'Enter dark pool name')}" style="margin-bottom: 10px; width: 100%;">
	  <h2>${t('Select members of the dark pool:', 'Select members of the dark pool:')}</h2>
	  <input type="text" id="userSearchInput" placeholder="${t('Search users...', 'Search users...')}" style="margin-bottom: 10px; width: 100%;">
	  <div id="userList" style="max-height: 300px; overflow-y: auto; border: 1px solid rgba(0, 255, 0, 0.5); padding: 10px;">
		${users.map(user => `
		  <label style="display: block; margin-bottom: 5px;">
			<input type="checkbox" value="${user._id}" style="margin-right: 5px;">
			${user.name} ${user._id === initiatorId ? t('(You)', '(You)') : ''}
		  </label>
		`).join('')}
	  </div>
	  <div class="selButMuCon">
	  		<button id="confirmSelectionMU">${t('Confirm', 'Confirm')}</button>
			  <button id="cancelSelectionMU">${t('Cancel', 'Cancel')}</button>
	  </div>
	`;
	document.body.appendChild(popup);

	const confirmButton = document.getElementById('confirmSelectionMU');
	const cancelButton = document.getElementById('cancelSelectionMU');
	const poolNameInput = document.getElementById('poolNameInput');
	const userSearchInput = document.getElementById('userSearchInput');
	const userListContainer = document.getElementById('userList');

	// Handle Search
	userSearchInput.addEventListener('input', () => {
	  const searchTerm = userSearchInput.value.toLowerCase();
	  userListContainer.innerHTML = users
		.filter(user => user.name.toLowerCase().includes(searchTerm))
		.map(user => `
		  <label style="display: block; margin-bottom: 5px;">
			<input type="checkbox" value="${user._id}" style="margin-right: 5px;">
			${user.name} ${user._id === initiatorId ? t('(You)', '(You)') : ''}
		  </label>
		`).join('');
	});

	// Confirm Selection
	confirmButton.addEventListener('click', () => {
	  const selectedUserIds = Array.from(userListContainer.querySelectorAll('input:checked')).map(input => input.value);
	  const poolName = poolNameInput.value.trim();
	  document.body.removeChild(popup);
	  if (!selectedUserIds.includes(initiatorId)) {
		selectedUserIds.push(initiatorId);
	  }
	  resolve({ selectedUserIds, poolName });
	});

	// Cancel Selection
	cancelButton.addEventListener('click', () => {
	  document.body.removeChild(popup);
	  resolve(null);
	});
  });
}


export {
  showCommunityInvitationPopup,
  handleResponseCM,
  checkAndShowCommunityInterface,  
  startCommunityTimer,
  showCommunityInterface,
  leaveCommunity,
  endCommunity,
  handleCreateCommunity,
  initializeCreateCommunityButton,
  getPortfolioId
};
